up.compiler('[image-upload]', (element) => {
  const previewImageSelector = '[image-upload-preview-image]'
  const input = element.querySelector('[image-upload-input]')

  input.addEventListener('change', (event) => {
    const fileToBeUploaded = event.target.files[0]

    const previewImageElement = element.querySelector(previewImageSelector)

    const reader = new FileReader()
    reader.addEventListener('load', (loadEvent) => {
      previewImageElement.src = loadEvent.target.result
      previewImageElement.classList.remove('-hidden')
    })
    reader.readAsDataURL(fileToBeUploaded)
  })
})
